/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIFeedbackEnum } from './APIFeedbackEnum';
import {
    APIFeedbackEnumFromJSON,
    APIFeedbackEnumFromJSONTyped,
    APIFeedbackEnumToJSON,
} from './APIFeedbackEnum';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIPatchedProductionFeedbackRequest
 */
export interface APIPatchedProductionFeedbackRequest {
    /**
     * 
     * @type {APIFeedbackEnum}
     * @memberof APIPatchedProductionFeedbackRequest
     */
    feedback?: APIFeedbackEnum;
    /**
     * 
     * @type {Date}
     * @memberof APIPatchedProductionFeedbackRequest
     */
    time?: Date;
    /**
     * 
     * @type {number}
     * @memberof APIPatchedProductionFeedbackRequest
     */
    count?: number;
}



/**
 * Check if a given object implements the APIPatchedProductionFeedbackRequest interface.
 */
export function instanceOfAPIPatchedProductionFeedbackRequest(value: object): value is APIPatchedProductionFeedbackRequest {
    return true;
}

export function APIPatchedProductionFeedbackRequestFromJSON(json: any): APIPatchedProductionFeedbackRequest {
    return APIPatchedProductionFeedbackRequestFromJSONTyped(json, false);
}

export function APIPatchedProductionFeedbackRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedProductionFeedbackRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'feedback': json['feedback'] == null ? undefined : APIFeedbackEnumFromJSON(json['feedback']),
        'time': json['time'] == null ? undefined : (new Date(json['time'])),
        'count': json['count'] == null ? undefined : json['count'],
    };
}

export function APIPatchedProductionFeedbackRequestToJSON(value?: APIPatchedProductionFeedbackRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'feedback': APIFeedbackEnumToJSON(value['feedback']),
        'time': value['time'] == null ? undefined : ((value['time']).toISOString()),
        'count': value['count'],
    };
}

